/* components/LightDarkToggle */

import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class HotspotProduct extends ThemeComponent {
    @Ref() hotspotButton!: HTMLButtonElement[];
    @Ref() hotspotCard!: HTMLButtonElement[];

    private showDelay = 300;
    private hideDelay = 800;

    init() {
        for (const button of this.hotspotButton) {
            const button_card = button.parentElement?.querySelector('[data-ref="hotspotCard"]');

            this.$listen(button, 'click', () => {
                button_card?.classList.toggle('is-active');
            });

            this.$listen(button, 'mouseover', () => {
                setTimeout(function() {
                    button_card?.classList.add('is-active');
                }, this.showDelay);
            });

            this.$listen(button, 'mouseleave', () => {
                setTimeout(function() {
                    button_card?.classList.remove('is-active');
                }, this.hideDelay);
            });
        }
    }
}
